import React from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import { languageData } from '../../utils/languageData';
import './Languages.css';

const Languages = () => {
    const { language } = useLanguage();
    const data = languageData[language];

    return (
        <div className="languages-page">
            <div className="hero-section">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1>{data.title}</h1>
                        <h3 className="hero-descriptionlan">"{data.subtitle}"</h3>
                    </div>
                    <div className="hero-decoration">
                        <div className="vertical-line"></div>
                        <div className="circle-container">
                            <div className="circle"></div>
                            <div className="circle"></div>
                            <div className="circle"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content-container">
                <div className="sections-grid">
                    {data.sections.map((section, index) => (
                        <section key={index} className="content-section">
                            <div className="section-header">
                                <span className="section-number">{(index + 1).toString().padStart(2, '0')}</span>
                                <h3>{section.title}</h3>
                            </div>
                            <p>{section.content}</p>
                            {section.reason && (
                                <div className="reason-box">
                                    <i className="fas fa-info-circle"></i>
                                    <p>{section.reason}</p>
                                </div>
                            )}
                        </section>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Languages;